import React, { useCallback } from 'react';
import { useFocusEffect } from '@react-navigation/native';
import { TWCPage } from '@components';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import { hourlyWeatherPageTestIDs } from '@constants';
import { hourlyForecastState, hourlyWeatherPageFocusIndex, screenReaderEnabledState } from '@store';

import { HourlyWeatherForecastPageContent } from './HourlyWeatherForecastPageContent/HourlyWeatherForecastPageContent';

export const HourlyWeatherForecastPage = () => {
  const [screenReaderEnabled] = useRecoilState(screenReaderEnabledState);
  const { error } = useRecoilValue(hourlyForecastState);
  const setFocusIndex = useSetRecoilState(hourlyWeatherPageFocusIndex);

  useFocusEffect(
    useCallback(() => {
      setFocusIndex(0);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  return (
    <TWCPage
      childIds={[
        // hourlyWeatherPageTestIDs.pipWidget,
        hourlyWeatherPageTestIDs.hourlyWeatherTopRow,
        hourlyWeatherPageTestIDs.hourlyWeatherConditionsWidget,
        hourlyWeatherPageTestIDs.hourlyWeatherTilesList,
      ]}
      firstFocus={
        screenReaderEnabled
          ? hourlyWeatherPageTestIDs.hourlyWeatherTopRow
          : hourlyWeatherPageTestIDs.hourlyWeatherTilesList
      }
      isMenuItem={false}
      pageID={hourlyWeatherPageTestIDs.hourlyWeatherPage}
    >
      <HourlyWeatherForecastPageContent error={error} />
    </TWCPage>
  );
};
